import { useMutation } from 'react-query';
import { useAPI } from '@axo/shared/data-access/provider';
import { communication_template_api } from '@axo/shared/data-access/api';

export function useFillCommunicationTemplate() {
  const api = useAPI();

  return useMutation(communication_template_api.fillTemplate(api));
}
